import api from "../../api/client";
import { API_ROUTE } from "../../api/endpoints";

export async function login(username, password) {
  const { data } = await api.post(API_ROUTE.AUTH, { username, password });
  return data;
}
